import Col from "react-bootstrap/Col";
import { SkeletonWrapper } from "../SkeletonWrapper";

type SkeletonCardProps = {
	index: number;
	colSize: number;
	colSizeSm: number;
	height: string;
	skeletonCount?: number;
};

export function SkeletonCard({
	index,
	colSize,
	colSizeSm,
	height,
	skeletonCount = 10,
}: SkeletonCardProps) {
	return (
		<Col lg={colSize} sm={colSizeSm} className="mb-6" key={`skeleton-card-${index}`}>
			<div className={`d-flex justify-content-center flex-column ${height} px-6 py-7`}>
				<SkeletonWrapper count={skeletonCount} />
			</div>
		</Col>
	);
}
